import React, {
  CSSProperties,
  FC,
  PropsWithChildren,
} from 'react';
import style from './index.module.scss';

interface IProps {
  onClick?: () => void;
  style?: CSSProperties;
}

export const ToolsButton: FC<IProps> = (props: PropsWithChildren<IProps>) => <div
  className={style.toolsButton}
  onClick={props.onClick}
  style={props.style}
>
  {props.children}
</div>;
